import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/Auth";
import { tokenVigente } from "./tokenVigente";

//Páginas privadas: hace falta usuario y token sin caducar. Si no, se limpia la sesión y se vuelve a la portada.
//(Antes dejaba pasar con el token caducado si había usuario en memoria, y cambiaba el estado durante el renderizado)
export const PrivateRoute = ({ children }) => {

    const { currentUser, sessionToken, logout } = useAuth();
    const valida = Boolean(currentUser) && tokenVigente(sessionToken);

    useEffect(() => {
        if (!valida && (currentUser || sessionToken)) {
            logout();
        }
    }, [valida]);

    if (!valida) {
        return <Navigate to="/" />;
    }
    return children;

}
